import { Box, Heading, Link, List, ListItem, Text } from '@chakra-ui/react';

import { PageTitles } from '@revelio/core';

import DashboardPage from '../../DashboardPage';
import { TrailPageConent } from '../../deliverables/trial-pages/components/trial-page-content';

const SAMPLE_FILES = [
  {
    label: 'Workforce Dynamics (.csv)',
    href: '/assets/csv/revelio_wf_dynam_geo_breakdown_sample.csv',
  },
  {
    label: 'Transitions (.csv)',
    href: '/assets/csv/revelio_transition_inflow_sample.csv',
  },
  {
    label: 'Job Postings (.csv)',
    href: '/assets/csv/revelio_postings_dynamics_sample.csv',
  },
  {
    label: 'Sentiment Data (.csv)',
    href: '/assets/csv/revelio_sentiment_individual_reviews_sample.csv',
  },
  {
    label: 'Layoff Notices (.csv)',
    href: '/assets/csv/revelio_layoffs_sample.csv',
  },
];

export const DataBuilderTrialPage = () => {
  return (
    <DashboardPage
      title={[PageTitles.DELIVERABLES, PageTitles.DATA_BUILDER]}
      loading={false}
      scrollY={true}
    >
      <TrailPageConent>
        <Box color="text.primary">
          <Heading as="h1" fontSize="4xl" fontWeight="semibold" mb={5}>
            Data Builder
          </Heading>
          <Text>
            Customize your own workforce dataset, no coding or technical skills
            required. Define the desired levels of aggregation, variables, and
            filters for any of our datasets (Workforce Dynamics, Transitions,
            Job Postings, Sentiment Data, Layoff Notices, Individual Level Data)
            to generate the insights most meaningful to your business.
          </Text>
          <Heading as="h2" fontSize="2xl" fontWeight="semibold" mt={4} mb={4}>
            Sample Files
          </Heading>
          <List
            spacing={1}
            styleType="disc"
            pl={6}
            sx={{ 'li::marker': { color: 'var(--chakra-colors-green-500)' } }}
          >
            {SAMPLE_FILES.map(({ label, href }) => (
              <ListItem key={href}>
                <Link
                  href={href}
                  color="green.500"
                  fontWeight="semibold"
                  textDecoration="underline"
                >
                  {label}
                </Link>
              </ListItem>
            ))}
          </List>
        </Box>
      </TrailPageConent>
    </DashboardPage>
  );
};
